<template>
    <div class="map-control" :style="{'background-color': theme.backgroundColor}">
        <div v-on:click="centerMap()">     
            <v-icon :color="theme.textColor">mdi-crosshairs</v-icon>
        </div>
        <div v-show="showMapTypeSwitch" v-on:click="changeMapType()">                   
            <v-icon :color="theme.textColor">mdi-map</v-icon>
        </div>
        <div v-on:click="zoomMapIn()">                   
            <v-icon :color="theme.textColor">mdi-plus</v-icon>
        </div>
        <div v-on:click="zoomMapOut()">                   
            <v-icon :color="theme.textColor">mdi-minus</v-icon>
        </div>
    </div>
</template>
<script>
import {layoutMixin} from '@/utils/layout-mixin'

export default {
    name: 'EspMapControl',
    mixins:[layoutMixin],
    components:{
        
    },
    props:{
        showMapTypeSwitch: {
            type: Boolean,
            default: true
        },

    },
    methods:{
        /**
         * Center the map
         * if gps is turned on, center map at user location. if gps is turned of, center map at event location
         */
        centerMap(){
            this.$emit('centerMap');
        },
        /**
         * Change the map type - normal | satelit
         */
        changeMapType(){
            this.$emit('changeMapType');
        },
        /**
         * Zoom in the map
         */
        zoomMapIn(){
            this.$emit('zoomMapIn');
        },
         /**
         * Zoom out the map
         */
        zoomMapOut(){
            this.$emit('zoomMapOut');
        }
    }
}
</script>
<style>
    div.gmnoprint{
        display: none;
    }
</style>
<style lang="scss" scoped>
    div.map-control{
        width: 50px;
        min-height: 80px;
        display: grid;
        place-items: center;        
        border-radius: 30px;
        border: 2px solid #fff;
        position: absolute;
        z-index: 1;
        bottom: 70px;
        right: 10px;
      
        @media only screen and (min-width: 769px) {            
            grid-template-columns: auto auto auto auto;
            width: auto;
            min-height: 40px;
            bottom: 70px;
            right: 10px;
        }

        @media only screen and (min-width: 960px) {  
            bottom: 60px;
        }
        
        @media only screen and (min-width: 1264px) {        
            bottom: 10px;
        }
        
        div{
            padding-top: 8px;
            padding-bottom: 8px;
            @media only screen and (min-width: 769px) {            
                padding-top: 0px;
                padding-bottom: 0px;
                padding-left: 8px;
                padding-right: 8px;
            }
            i{
                cursor: pointer;
                justify-content: center;
                text-align: center;
                display: flex;
            }
        }
    }
</style>